import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import NSAWidget from './NSA';
const PHRASE = 'Network Spinal Analysis';
const NSATooltip = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);
    const open = useCallback(() => setIsOpen(true), []);
    const close = useCallback(() => setIsOpen(false), []);
    const toggle = useCallback(() => setIsOpen((current) => !current), []);
    useEffect(() => {
        if (!isOpen) {
            return undefined;
        }
        const handlePointerDown = (event) => {
            if (containerRef.current &&
                !containerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handlePointerDown);
        document.addEventListener('touchstart', handlePointerDown);
        document.addEventListener('keydown', handleKeyDown);
        const shouldLockScroll = window.matchMedia('(max-width: 600px)').matches;
        const scrollY = window.scrollY;
        const previousBodyOverflow = document.body.style.overflow;
        const previousBodyPosition = document.body.style.position;
        const previousBodyTop = document.body.style.top;
        const previousBodyWidth = document.body.style.width;
        if (shouldLockScroll) {
            document.body.style.overflow = 'hidden';
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.width = '100%';
        }
        return () => {
            document.removeEventListener('mousedown', handlePointerDown);
            document.removeEventListener('touchstart', handlePointerDown);
            document.removeEventListener('keydown', handleKeyDown);
            if (shouldLockScroll) {
                document.body.style.overflow = previousBodyOverflow;
                document.body.style.position = previousBodyPosition;
                document.body.style.top = previousBodyTop;
                document.body.style.width = previousBodyWidth;
                window.scrollTo(0, scrollY);
            }
        };
    }, [isOpen]);
    return (_jsxs("span", { ref: containerRef, className: isOpen ? 'nsa-term is-open' : 'nsa-term', role: "button", tabIndex: 0, "aria-expanded": isOpen, onMouseEnter: open, onMouseLeave: close, onClick: toggle, onKeyDown: (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                toggle();
            }
        }, children: [children, _jsxs("span", { className: "nsa-popover", role: "tooltip", children: [_jsx("button", { type: "button", className: "nsa-popover-close", "aria-label": "Close", onClick: (event) => {
                            event.stopPropagation();
                            close();
                        }, children: "\u00D7" }), _jsx(NSAWidget, {})] })] }));
};
/**
 * Splits a description string and wraps every occurrence of
 * "Network Spinal Analysis" in a hoverable / tappable tooltip, leaving
 * the surrounding text untouched.
 */
export function withNsaTooltip(text) {
    const parts = text.split(PHRASE);
    return parts.map((part, index) => (_jsxs(React.Fragment, { children: [part, index < parts.length - 1 && _jsx(NSATooltip, { children: PHRASE })] }, index)));
}
export default NSATooltip;
